// extracted by mini-css-extract-plugin
export default {"root":"rbPGM","displayed":"nRb7m","frame":"Lo3bS"};